import moment from 'moment'

import { OnSchedHelpers }  from '../OnSchedHelpers'
import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'


export const CalendarDay = (event, element) => {
  const el = document.getElementById(element.id);
  
  var dayClicked = event.target;
  var elTimesContainer = document.getElementById('available-times-row');
  var elAvailableTimes = document.getElementById('onsched-available-times-col');
  var elAvailableTimesOptions = [...document.querySelectorAll('.onsched-available-times .onsched-times-column ul li button')];
  var elAvailableDateRange = elAvailableTimesOptions.map(timeChip => timeChip.dataset);

  var sameDayClicked = [...new Set(elAvailableDateRange.map(timeChipData => timeChipData.date))].includes(dayClicked.dataset.date)

  // Open times container if closed
  if (!elTimesContainer.classList.contains('display-times')) {
      elTimesContainer.classList.add('display-times');
  }
  if (elTimesContainer.clientWidth < 768) {
      document.documentElement.scrollTo({
        top: elAvailableTimes.offsetTop,
        behavior: 'smooth',
      });
  }

  if (!sameDayClicked && elAvailableTimes) {
      if (!elAvailableTimes.classList.contains('loading')) {
        elAvailableTimes.classList.add('loading');
      }
  }

  // implement logic here to switch the selection in UI and trigger availability call
  var calendarDays = document.querySelectorAll(".onsched-calendar-rowgroup .day");
  [].forEach.call(calendarDays, function (el) {
      el.className = el.className.replace(/\bselected\b/g, ""); // unselect all calendar days in UI
      // el.classList.remove("selected"); above method more browser friendly
  });

  // call logic to select day with the clicked element
  if (!dayClicked.classList.contains("selected"))
      dayClicked.classList.add("selected");

  var elSelectTimezone = document.getElementById('onsched-timezone-button');
  const timezoneName = elSelectTimezone.dataset.tz;

  var title = document.querySelector(".onsched-calendar-header .onsched-calendar-title");
  var clickedDate = OnSchedHelpers.ParseDate(dayClicked.dataset.date);
  var url = OnSchedHelpers.CreateAvailabilityUrl(element.onsched.apiBaseUrl, element.params, clickedDate, timezoneName);
  if (clickedDate.getMonth() != title.dataset.month || clickedDate.getFullYear() != title.dataset.year) {
      var calendarHtml = OnSchedTemplates.calendarSelectorFromDate(clickedDate, element.onsched.locale);
      var elCalendar = document.querySelector(".onsched-calendar");
      elCalendar.innerHTML = calendarHtml;

      // calculate available days to pull when mounting
      url = OnSchedHelpers.AddUrlParam(url, "dayAvailabilityStartDate",
          OnSchedHelpers.CreateDateString(OnSchedHelpers.GetFirstCalendarDate(clickedDate)));
      url = OnSchedHelpers.AddUrlParam(url, "dayAvailability", OnSchedHelpers.GetCalendarDays(clickedDate));
    }
    if (!sameDayClicked) {
        // check if day clicked avail has already been loaded
        const elHiddenTimes = document.getElementById('onsched-hidden-loaded-times');
        if (elHiddenTimes) {
            const startDateQueried = moment(elHiddenTimes.dataset.startDate);
            const endDateQueried = moment(elHiddenTimes.dataset.endDate);
            const newDateSelected = moment(clickedDate);

            if (endDateQueried.diff(newDateSelected) > 0 && newDateSelected.diff(startDateQueried) >= 0) {
                // if true use existing results

                let detail = Object.assign({}, elHiddenTimes.dataset);
                
                detail.availableDays = JSON.parse(elHiddenTimes.dataset.availableDays);
                detail.calendarDaySelected = clickedDate;
                detail.availableTimes = [];
                
                document.querySelectorAll('#onsched-hidden-loaded-times ul li button').forEach(t => detail.availableTimes.push({
                    allowableBookings: t.dataset.allowableBookings,
                    allowableCapacity: t.dataset.allowableCapacity,
                    availableBookings: t.dataset.availableBookings,
                    availableCapacity: t.dataset.availableCapacity,
                    date: t.dataset.date,
                    displayTime: t.dataset.displayTime,
                    duration: t.dataset.duration,
                    endDateTime: t.dataset.endDateTime,
                    resourceId: t.dataset.resourceId,
                    startDateTime: t.dataset.startDateTime,
                    time: t.dataset.time,
                    travelAppointmentId: t.dataset.travelAppointmentId,
                    travelTimeMins: t.dataset.travelTimeMins
                }));
                
                el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
                OnSchedResponse.GetAvailability(element, detail);
            }
            else {
              OnSchedRest.Get(url, function (response) {
                  let detail = response;
                  
                  el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
                  OnSchedResponse.GetAvailability(element, response, dayClicked?.dataset?.date);
              })
            }
          }
          else {
              OnSchedRest.Get(url, function (response) {
                  let detail = response;
                  
                  el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
                  OnSchedResponse.GetAvailability(element, response, dayClicked?.dataset?.date);
              })
          }
    }
}
